"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var date_fns_1 = require("date-fns");
var ui_components_1 = require("@l2p/ui-components");
var common_hooks_1 = require("@l2p/common-hooks");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ActiveCoolingOffCard = function (_a) {
    var data = _a.data;
    var t = (0, next_intl_1.useTranslations)('translation');
    var openLiveChatWidget = (0, common_hooks_1.useLiveChatVisibility)();
    var config = (0, swr_hooks_1.useConfig)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('coolingOff')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, t('coolingOffDescription')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.textContainer }, (data === null || data === void 0 ? void 0 : data.dateTo) && (react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.property }, t('validUntil')),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.value }, (0, date_fns_1.format)(new Date(data.dateTo), 'HH:mm, dd-LL-yy'))))),
            !(config === null || config === void 0 ? void 0 : config.liveChatShouldDisabled) && (react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
                react_1.default.createElement(ui_components_1.FixedButton, { variant: "outline", color: "primary", width: "100%", maxWidth: "100%", onClick: openLiveChatWidget }, t('cancelViaSupport')))))));
};
exports.default = ActiveCoolingOffCard;
